// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"26":"e42583e9","94":"f17275bf","767":"e823892d"}[chunkId] + ".chunk.css";
};